(function () {
    var directivesModule = angular.module('customeDirectivesModule');
    directivesModule.directive('dropdownList',['$document', function ($document) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                items: '=',
                selectedItem: '=',
                disabledControl: '=',
                registerItemId: '=',
                isRegisterItem: '='
            },
            controller: ['$window', '$scope', '$filter', '$timeout', dropdownListController],
            controllerAs: 'vm',
            templateUrl: '/app/shared/directives/dropdownListTemplate.html',
            link: function (scope, element, attrs, ctrl) {
                scope.translation = globalResources;
                scope.valueName = 'id';
                scope.textName = 'name';

                if (attrs.value) {
                    scope.valueName = attrs.value;
                }

                if (attrs.text) {
                    scope.textName = attrs.text;
                }

                if (attrs.disabledField) {
                    scope.disabled = attrs.disabledField;
                }

                if (attrs.disabledInfo) {
                    scope.disabledInfo = attrs.disabledInfo;
                }

                if (attrs.iconClasses) {
                    scope.iconClasses = attrs.iconClasses;
                }

                if(attrs.searchable){
                    scope.searchable = attrs.searchable == 'true';
                }
                if (attrs.isRegisterItem) {
                    scope.isRegisterItem = attrs.isRegisterItem == 'true';
                }

                scope.$watch('items', function (items) {
                    scope.visibleItems = items;
                });

                scope.showDropdownList = false;
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                      .find(event.target)
                      .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.showDropdownList = false;
                    scope.$apply();
                });

            }
        }
    }]);

    function dropdownListController($window, $scope, $filter, $timeout) {
        var vm = this;

        vm.nextPage = nextPage;
        vm.selectItem = selectItem;
        vm.removeCurrentItem = removeCurrentItem;
        vm.onSearch = onSearch;
        vm.onDataNavigating = onDataNavigating;
        vm.onEnter = onEnter;
        vm.registerItemId = $scope.registerItemId;

        vm.currentRowIndex = 0;
        var infiniteScrollLoadsize = (HandbookConfiguration.InfiniteScrollLoadSize == "0" || HandbookConfiguration.InfiniteScrollLoadSize == 0) ?
          0 :
          parseInt(HandbookConfiguration.InfiniteScrollLoadSize);

        vm.infiniteItems = [];
        vm.busy = false;
        vm.newTotalItems = 0;
        vm.selectedItemText = '';
        vm.currentIndex = -1;
        vm._scrollHeight = 0;
        vm.visibleItems = [];
        vm.infiniteItems = getAPage();
        vm.showPopup = showPopup;
        vm.showPopupWhenClickInput = showPopupWhenClickInput;

        function selectItem(item, index) {
            if ($scope.disabled && !item[$scope.disabled]) {
                return;
            }
            $scope.selectedItem = item;
            vm.selectedItem = item;           
            if ($scope.isRegisterItem) {
                vm.registerItemId = item.registerItemId;
                $scope.registerItemId = item.registerItemId;
            }
            
            $scope.showDropdownList = false;
            vm.selectedItemText = item[$scope.textName];
            vm.currentItem = item;
            vm.currentIndex = index;
        }

        function showPopup() {
            if (!$scope.disabledControl) {
                $scope.showDropdownList = !$scope.showDropdownList;
            }
        }

        function showPopupWhenClickInput() {
            if (!$scope.disabledControl) {
                if (!$scope.searchable) {
                    $scope.showDropdownList = !$scope.showDropdownList;
                }
            }
        }

        function removeCurrentItem() {
            vm.selectedItemText = '';
            if ($scope.isRegisterItem) {
                vm.registerItemId = null;
                $scope.registerItemId = null;
            }
            resetData();
            if ($scope.visibleItems.length > 0)
                vm.visibleItems = $scope.visibleItems.slice();
            nextPage();
        }
        

        function onSearch(keyEvent) {
            if (keyEvent.which != 38 && keyEvent.which != 40) {
                if (keyEvent.which == 13) {
                    enterSelectItem();
                }
                else {
                    $scope.showDropdownList = true;
                    resetData();
                    var searchObject = {};
                    searchObject[$scope.textName] = vm.selectedItemText;
                    if ($scope.visibleItems.length > 0) {
                        var itemsVisible = $scope.visibleItems.slice();
                        vm.visibleItems = $filter('filter')(itemsVisible, searchObject);
                        nextPage();
                    }
                }
            }
        };

        function onEnter(keyEvent) {
            if (keyEvent.which == 13) {
                enterSelectItem();
            }
        };

        function onDataNavigating(keyEvent) {
            if ((keyEvent.which == 38 || keyEvent.which == 40) && $scope.showDropdownList) {
                setcurrentItemInPopup(keyEvent.which);
            }
        };

        function setcurrentItemInPopup(keyCode) {
            if (keyCode == 38 && vm.currentIndex > 0) {
                vm.currentIndex -= 1;
                vm._scrollHeight -= 24;
            } 
            if (keyCode == 40 && vm.currentIndex < vm.infiniteItems.length - 1) {
                vm.currentIndex += 1;
                vm._scrollHeight += 24;
            }
            if (vm.currentIndex == 0)
                vm._scrollHeight = 0;
            if ((keyCode == 40 && vm._scrollHeight + 10 > angular.element('#selectId')[0].clientHeight) || (keyCode == 38))
                angular.element('#selectId')[0].scrollTop = vm._scrollHeight;
            
            if (vm.currentIndex < vm.infiniteItems.length) {
                vm.currentItem = vm.infiniteItems[vm.currentIndex];
            }
        };

        function getAPage() {
            if (vm.visibleItems != undefined) {
                var data = [];
                var startIndex = vm.currentRowIndex;
                var endIndex = startIndex + infiniteScrollLoadsize;
                for (var i = startIndex; i < endIndex; i++) {
                    if (vm.currentRowIndex < vm.visibleItems.length) {
                        data.push(vm.visibleItems[i]);
                        vm.currentRowIndex += 1;
                    } else {
                        break;
                    }
                }
                return data;
            }
        }

        $scope.$watch('items', function (items) {
            resetData();
            $scope.visibleItems = items;
            if ($scope.visibleItems !=null && $scope.visibleItems !=undefined && $scope.visibleItems.length > 0)
            {
                vm.visibleItems = $scope.visibleItems.slice();
                vm.infiniteItems = getAPage();
            }else
            {
                vm.visibleItems = null;
                vm.infiniteItems = null;
            }
        });

        $scope.$watch('selectedItem', function (selectedItem) {
            if (selectedItem != null && selectedItem != undefined) {
                vm.selectedItem = selectedItem;
                vm.selectedItemText = selectedItem[$scope.textName];
                vm.currentItem = selectedItem;
            } else {
                vm.selectedItemText = '';
                vm.selectedItem = null;
                vm.currentItem = null;
            }
        });

        function nextPage() {
            if (vm.busy) return;
            vm.busy = true;
            if (vm.infiniteItems != undefined) {
                if (infiniteScrollLoadsize == 0) {
                    vm.infiniteItems = scope.visibleItems;
                } else {
                    if (vm.infiniteItems.length <= vm.newTotalItems) {
                        vm.infiniteItems = vm.infiniteItems.concat(getAPage());
                    }
                }
                vm.newTotalItems = vm.infiniteItems.length;
            }
            vm.busy = false;
        };

        function resetData() {
            $scope.selectedItem = null;
            vm.selectedItem = null;
            vm.currentItem = null;          
            vm.currentIndex = -1;
            vm._scrollHeight = 0;
            vm.currentRowIndex = 0;
            vm.infiniteItems = [];
        };

        function enterSelectItem() {
            if (vm.currentItem != null && (($scope.disabled && vm.currentItem[$scope.disabled]) || $scope.disabled == undefined || $scope.disabled == null)) {
                $scope.selectedItem = vm.currentItem;
                vm.selectedItem = vm.currentItem;
                $scope.showDropdownList = false;
                vm.selectedItemText = vm.currentItem[$scope.textName];
            }
        };
    }
})();